import {Text, Tooltip, Octicon} from '@primer/react'
import {AlertIcon} from '@primer/octicons-react'
import {TimelineRow} from './row/TimelineRow'

export function FallbackEvent(): JSX.Element {
  return (
    <TimelineRow
      showActorName={false}
      showAgoTimestamp={false}
      leadingIcon={<Octicon icon={AlertIcon} />}
      highlighted={false}
      actor={null}
      createdAt={''}
      actorAvatar={null}
      deepLinkUrl={''}
    >
      <Tooltip aria-label="Check your browser's console for more details" direction="ne">
        <Text>Event unavailable</Text>
      </Tooltip>
    </TimelineRow>
  )
}

try{ FallbackEvent.displayName ||= 'FallbackEvent' } catch {}